import React from 'react'
import Routing from './Routing'
export default () => (<Routing />)
